<script setup lang="ts">
import { ref } from 'vue'

import { getClasses } from '~/js/composables/classes'

interface Props {
    color?: string|null,
    utilities?: string
}

withDefaults(defineProps<Props>(), {
    color: null,
    utilities: ''
})

const classes = ref({
    _default: {
        color: 'text-blue-500',
        font: 'font-title font-bold uppercase',
        size: 'text-base',
    }

})
</script>

<template>
    <span :class="[
        getClasses(classes, '_default'), 
        color,
        utilities, 
    ]">
        <slot></slot>
    </span>
</template>